import { Component, Injectable, OnInit } from '@angular/core';
import { AuthService } from '../../../authentication/services/auth.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { PostTranslationsService } from '../../services/postTranslations.service';
import { APP_SETTINGS } from '../../../shared/models/backofficeConfiguration';
import * as moment from 'moment-timezone';
import { PendingTranslation } from '../../model/PendingTranslation';
import { FeedsService } from '../../services/feeds.service';
import { Feed } from '../../model/Feed';
import { PendingTranslationsFilter } from '../../model/PendingTranslationsFilter';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Author } from '../../../shared/models/Author';
import { AuthorService } from '../../../shared/services/author.service';
@Component({
  selector: 'app-pending-post-translations-filter',
  templateUrl: '../templates/pendingPostTranslationsFilter.component.html'
})

@Injectable()
export class PendingPostTranslationsFilterComponent implements OnInit {

  title = 'Pending Translations';
  DashboardUrl = '';
  Items?: PendingTranslation[] = null;
  Progress: boolean = false;
  CurrentLanguage: string;
  BreakingNewsFeedId: string = APP_SETTINGS.PostTranslationsConfig.BreakingNewsFeedId;
  FeedId: string = APP_SETTINGS.PostTranslationsConfig.NewsFeedId;
  IsHighlighted: boolean;
  IsBreaking: boolean = true;
  DateFromUtc: moment.Moment = moment().startOf("day");
  DateToUtc: moment.Moment;
  TitleText: string;
  AuthorSelected: Author;

  Feeds: Feed[] = [];

  constructor(
    private urlService: UrlService,
    private alertService: AlertService,
    private authService: AuthService,
    private feedsService: FeedsService,
    private postTranslationsService: PostTranslationsService,
    private authorService: AuthorService) {
  }

  ngOnInit() {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.CurrentLanguage = this.authService.getActualLanguage().cultureNameISO;
    moment.tz.setDefault('UTC');

    this.feedsService.GetFeeds().subscribe(feeds => this.Feeds = feeds);
    this.Filter();
  }

  Filter(): void {
    this.Progress = true;
    this.Items = [];
    this.alertService.removeAll();
    this.ExecuteFilter(this.FeedId);
    if (this.IsBreaking)
      this.ExecuteFilter(this.BreakingNewsFeedId);
  }

  authorChange(author: Author) {
    this.AuthorSelected = author;
  }
  ExecuteFilter(feedId): void {
    const filter: PendingTranslationsFilter = {
      dateFrom: this.DateFromUtc,
      dateTo: this.DateToUtc,
      feedId: feedId,
      isHighlighted: this.IsHighlighted,
      sourceTitle: this.TitleText,
      authorId: this.AuthorSelected ? this.AuthorSelected.AuthorId : null
    };

    this.postTranslationsService.GetPendingTranslations(this.CurrentLanguage, filter)
      .subscribe(pendingTranslations => {
        pendingTranslations.forEach(item => {
          if (item.feedId === this.BreakingNewsFeedId)
            this.Items.unshift(item);
          else
            this.Items.push(item);
        });
        this.Progress = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/postTranslations/components/scripts/pendingPostTranslationsFilter.component.ts